module.exports = __webpack_public_path__ + "img/popupAd-day8.8c441318.png";